import { Box } from '@chakra-ui/react';
import { EnvironmentHeader } from './containers/EnvironmentHeader';
import { EnvironmentList } from './containers/EnvironmentList';
import { EnvironmentRegistrationModal } from './containers/EnvironmentRegistrationModal';
import { EnvironmentEditModal } from './containers/EnvironmentEditModal';
import { EnvironmentDeleteModal } from './containers/EnvironmentDeleteModal';

export const ReleaseEnvironmentPageView = () => (
  <Box m="40px">
    {/* ヘッダ */}
    <EnvironmentHeader />
    {/* 環境一覧 */}
    <EnvironmentList />
    {/* 環境登録モーダル */}
    <EnvironmentRegistrationModal />
    {/* 環境更新モーダル */}
    <EnvironmentEditModal />
    {/* 環境削除モーダル */}
    <EnvironmentDeleteModal />
  </Box>
);
